import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿El material está actualizado?',
    answer: 'Sí, incluye los cambios y requerimientos para 2026.'
  }, {
    question: '¿Necesito saber mucho inglés?',
    answer: 'No, la guía está diseñada para personas con inglés básico o intermedio.'
  }, {
    question: '¿Es un libro físico?',
    answer: 'Es un producto digital (PDF + Bundle) de descarga inmediata.'
  }, {
    question: '¿Puedo leerlo en mi celular?',
    answer: 'Sí, está optimizado para dispositivos móviles y computadoras.'
  }];
  return <section className="w-full bg-[#F7F5F0]" data-id="element-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-52">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-53">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-54">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-55">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-56">
                  <span className="font-semibold text-lg text-[#1B2A4A] pr-4" data-id="element-57">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-6 h-6 text-[#C9A84C] flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-58" />
                </button>

                <AnimatePresence data-id="element-59">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-60">
                      <div className="px-6 pb-5 text-gray-700" data-id="element-61">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}